import { AppBar, Badge, Box, Button, IconButton, Tooltip, Typography } from '@mui/material'
import { useStyles } from './styles'
import { useContextState } from '../../../hooks/theme'
import { Images } from '../../image'
import BaseMenu, { ItemMenu } from '../../baseMenu'
import { useNavigate } from 'react-router-dom'
import { icons } from '../../../utils/icons'
import { useBody } from './body'
import { FloatingList } from '../../floatList'
import SnackSimple from '../../snackbars/simple'
import { images } from '../../../utils/images'
import { useMenuList } from './menu'
import { ItemNotifyProps } from './components/itemNotificationBell/types'
import { SnackbarFormat } from '../../../utils/types/generals'
import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction } from 'react'

const Header = ({ page, totalItems, setPage, totalPages, openMenu, loading, notifications, snackbar, getNotifications, listLoadingNotifications, closeSnackbar, removeNotifications, }: {
  openMenu: () => void;
  notifications: ItemNotifyProps[];
  loading: Record<string, boolean>;
  listLoadingNotifications: Record<string, boolean>
  getNotifications: (unique?: boolean | undefined, refresh?: boolean | undefined) => Promise<void>
  snackbar: SnackbarFormat
  removeNotifications: ({ id, all, }: {
    id?: string[];
    all?: boolean;
  }) => Promise<void>
  closeSnackbar: () => void;
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  totalPages: number;
  totalItems: number;
}) => {
  const menuList = useMenuList()
  const { anchorEl, handleClick, refreshNotifications } = useBody({ getNotifications, setPage, page })
  const navigate = useNavigate()
  const { colors, state } = useContextState()
  const styles = useStyles(colors)
  const { t } = useTranslation()

  const onClick = (item: ItemMenu) => {
    if (item?.value == '2') {
      navigate('/auth/logOut')
      return
    }
  }

  const header = (
    <Box sx={styles.header}>
      <Box sx={styles.containerTitle}>
        <IconButton onClick={() => { refreshNotifications() }} sx={styles.refresh}>{icons('refresh')}</IconButton>

        <Typography sx={styles.headerTitle}>Notificaciones</Typography>
      </Box>

      {notifications.length && <Button onClick={() => { removeNotifications({ all: true }) }} sx={styles.headerButton} variant='text'>Descartar todas</Button>}
    </Box>
  )

  return (
    <AppBar elevation={0} component="nav" sx={styles.navBar}>
      <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
      <IconButton onClick={() => openMenu()} sx={styles.menu}>{icons('menu')}</IconButton>
      <Box sx={styles.flexGrow} />
      <Box sx={styles.leftTools}>
        <Badge badgeContent={!!totalItems ? totalItems : null} sx={styles.badge}>
          <Tooltip title={t('ToolTips.notifications')}>
            <IconButton onClick={(e) => { handleClick({ event: e, type: 'bell' }) }} sx={styles.bell}>{icons('bell-rounded')}</IconButton>
          </Tooltip>
        </Badge>

        <Tooltip title={t('ToolTips.profile')}>
          <IconButton onClick={(e) => { handleClick({ event: e, type: 'profile' }) }} ><Images src={state?.picture || images.profileHeader} sx={styles.flag} /></IconButton>
        </Tooltip>

        <FloatingList totalPages={totalPages} page={page} setPage={setPage} removeNotifications={removeNotifications} listLoadingNotifications={listLoadingNotifications} refresh={refreshNotifications} header={header} isLoad={loading.notification} isLoadRest={loading.secondPages} close={() => { handleClick({ event: null, type: 'bell' }) }} data={notifications} anchorEL={anchorEl.bell} />

        <BaseMenu sx={styles.menuList} anchorEl={anchorEl.profile} setAnchorEl={() => { handleClick({ event: null, type: 'profile' }) }} menuItems={menuList} click={onClick} />
      </Box>
    </AppBar>
  )
}

export default Header
